import {
  color,
  lineColor,
  yAxisLabelSize,
  xAxisLabelSize,
  titleTextSize,
  grid,
  intervalCount
} from "@/modules/Charts/theme.js";
//let grid1 = {
//		top:60,
//		left:'1%',
//		bottom:'10%',
//		right:'3%',
//		containLabel:true
//};
const itemStyle = {
  pidai: getItemStyle('#00C0E3', '#00F8C9', 'grey'),
  chuchen: getItemStyle('rgba(86,215,210,1)', 'rgba(12,178,129,1)'),
  xicheji: getItemStyle('#AA7157', '#497AAA'),
}

function getOpt(xdata = [], ydata = [], params) {
  grid.left = "3%";
  //	grid.top="50%";
  //	let legend = [];
  //let yAxis = []
  //	let series = ydata.map((item,index)=>{
  //  
  //	legend.push(item.name);
  //  ydataOpt.color = colors[index];
  //
  //  if(index === 0){
  //    yAxis.push({...yAxisOpt});
  //  }else{
  //    yAxis.push({...yAxisOpt2});
  //  }
  //
  //	return {...ydataOpt,...item,yAxisIndex:index}
  //})

  return {
    backgroundColor: "transparent",
    title: {
      show: false,
      text: (() => {
        if (!params.name) return "";
        return `{a|''}  {b|${params.name}}`
      })(),
      top: 0,
      left: 0,
      textAlign: "left",
      textStyle: {
        color: "#fff",
        fontSize: "14",
        rich: {
          a: {
            width: 5,
            height: 21,
            color: 'transparent',
            //          shadowBlur:3,
            //          shadowColor:"#C9FFFB",
            //          borderRadius:2,
            //						backgroundColor:"red",
            //          backgroundColor:"linear-gradient(180deg,rgba(64,182,255,1) 0%,rgba(21,118,196,1) 100%)",
            backgroundColor: {
              image: require('../../../../Charts/img/icon_gear_default.png')
            }
          },
          b: {
            //          color:"#2CA6FF",
            fontSize: titleTextSize,
          }
        }
      }
    },
    tooltip: {
      trigger: 'axis',
      formatter(params) {
        let str = "";
        str += `<div class="tooltip" style="background: #000;padding: 10px;font-size:20px!important;line-height:30px;">`;
        if (params[2].data.value === 1) {
          //无数据 (启 会被暂无数据遮住)
          str += `<div>时间：${params[2].axisValue}</div>`;
          str += `<div>启停信号：${params[2].seriesName}</div>`;
        } else if (params[2].data.value === 1) {
          //开
          str += `<div>时间：${params[0].axisValue}</div>`;
          str += `<div>启停信号：${params[0].seriesName}</div>`;
        } else {
          //停
          str += `<div>时间：${params[1].axisValue}</div>`;
          str += `<div>启停信号：${params[1].seriesName}</div>`;
        }
        str += `</div>`;
        //		params.forEach((item,i)=>{
        //			if()
        //			str+=`<div class="tooltip" style="font-size:30px;line-height:40px;">${item.name}：${item.value}</div>`
        //		})
        return str;
      },
    },
    //  tooltip: {
    //      trigger: 'axis',
    //      axisPointer: {
    //      lineStyle: {
    //        type:"dotted"
    //      },
    //      backgroundColor: "transparent",
    ////      textStyle:{
    ////      	fontSize:30
    ////      },
    ////				formatter:(param) =>{
    ////					console.log(param)
    ////					return '<span style="font-size:20px;color: #657180; margin-left: 8px; float: right;">{a} <br/>{b} : {c}%</span>'
    ////				}
    ////      formatter: '<span style="font-size:20px;color: #657180; margin-left: 8px; float: right;">{a} <br/>{b} : {c}%</span>'
    //    }
    //  },
    //  userGrid:{
    //    ...params.grid
    //  },
    legend: {
      //    show:false,//暂时隐藏吧，需要显示可以从params配置
      selectedMode: false, //取消图例上的点击事件
      top: 0,
      right: 0,
      itemGap: 30, //图例距离
      textStyle: {
        color: "#fff",
        fontSize: 20
      }
    },
    grid,
    dataZoom: {
      show: false
    },
    animation: false,
    xAxis: {
      type: 'category',
      axisTick: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: lineColor
        }
      },
      axisLabel: {
        //    	width: 200,
        //    	rich:{
        //    		a:{
        //    			width:200
        //    		}
        //    	},
        padding: [0, 0, 0, 80],
        color,
        fontSize: 18, //bar字体设置
        //      interval:intervalCount,
        //      showMinLabel: true,
        //      showMaxLabel: true,
      },
      data: xdata
    },
    yAxis: {
      type: 'category',
      data: [0, 1],
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: lineColor
        }
      },
      axisLabel: {
        show: false,
        //    	inside: true,
        color,
        fontSize: 18 //bar字体设置
      },
      boundaryGap: 0
    },
    series: [{
      zlevel: 2,
      data: ydata[1],
      type: 'bar',
      //    name:params.name || "",
      name: "启",
      barCategoryGap: params.barCategoryGap || -1,
      //    itemStyle: params.itemStyle || itemStyle[params.themeName] || getItemStyle()
      itemStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [{
              offset: 0,
              color: "#0FE569"
            }, {
              offset: 1,
              color: "#0FE569"
            }]
          )
        }
      }
    }, {
      zlevel: 1,
      name: "停",
      barCategoryGap: -1,
      data: ydata[0],
      barGap: '-100%', //柱状图重叠
      type: "bar",
      //			itemStyle:itemStyle[params.themeName]
      itemStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [{
              offset: 0,
              color: "#4A7BBF"
            }, {
              offset: 1,
              color: "#4A7BBF"
            }]
          )
        }
      }
    }, {
      zlevel: 2,
      data: ydata[2],
      type: 'bar',
      name: "无数据",
      barCategoryGap: params.barCategoryGap || -1,
      itemStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [{
              offset: 0,
              color: "grey"
            }, {
              offset: 1,
              color: "grey"
            }]
          )
        }
      }
    }]
  }
}

function getItemStyle(startColor = '#1FFFF6', endColor = '#4BBE73') {
  return {
    normal: {
      color: new echarts.graphic.LinearGradient(
        0, 0, 0, 1,
        [{
          offset: 0,
          color: startColor
        }, {
          offset: 1,
          color: endColor
        }]
      )
    }
  }
}

export default getOpt;

import {
  initOptMethod
} from "@/modules/Charts/index.js"
let getOption = initOptMethod(getOpt);

export {
  getOption,
  getItemStyle
}
